import { Directive } from '@angular/core';

@Directive({
  selector: '[appPress]'
})
export class PressDirective {

  constructor() { }

}
